/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateConversation = /* GraphQL */ `
  subscription OnCreateConversation(
    $createdAt: AWSDateTime
    $id: ID
    $summary: String
    $title: String
    $userId: ID
  ) {
    onCreateConversation(
      createdAt: $createdAt
      id: $id
      summary: $summary
      title: $title
      userId: $userId
    ) {
      id
      userId
      title
      summary
      createdAt
      __typename
    }
  }
`;
export const onCreateDocument = /* GraphQL */ `
  subscription OnCreateDocument(
    $content: AWSJSON
    $unique_id: ID
    $s3Uri: String
    $title: String
    $type: String
  ) {
    onCreateDocument(
      content: $content
      unique_id: $unique_id
      s3Uri: $s3Uri
      title: $title
      type: $type
    ) {
      unique_id
      title
      s3Uri
      type
      content
      uploadedBy
      source
      uploadedAt
      insights
      __typename
    }
  }
`;
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage(
    $content: AWSJSON
    $conversationId: ID
    $id: ID
    $supportingContent: AWSJSON
    $userId: ID
  ) {
    onCreateMessage(
      content: $content
      conversationId: $conversationId
      id: $id
      supportingContent: $supportingContent
      userId: $userId
    ) {
      id
      conversationId
      userId
      isBot
      content
      supportingContent
      citations
      explanation
      timestamp
      __typename
    }
  }
`;
export const onDeleteConversation = /* GraphQL */ `
  subscription OnDeleteConversation(
    $createdAt: AWSDateTime
    $id: ID
    $summary: String
    $title: String
    $userId: ID
  ) {
    onDeleteConversation(
      createdAt: $createdAt
      id: $id
      summary: $summary
      title: $title
      userId: $userId
    ) {
      id
      userId
      title
      summary
      createdAt
      __typename
    }
  }
`;
export const onDeleteDocument = /* GraphQL */ `
  subscription OnDeleteDocument(
    $content: AWSJSON
    $unique_id: ID
    $s3Uri: String
    $title: String
    $type: String
  ) {
    onDeleteDocument(
      content: $content
      unique_id: $unique_id
      s3Uri: $s3Uri
      title: $title
      type: $type
    ) {
      unique_id
      title
      s3Uri
      type
      content
      uploadedBy
      source
      uploadedAt
      insights
      __typename
    }
  }
`;
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage(
    $content: AWSJSON
    $conversationId: ID
    $id: ID
    $supportingContent: AWSJSON
    $userId: ID
  ) {
    onDeleteMessage(
      content: $content
      conversationId: $conversationId
      id: $id
      supportingContent: $supportingContent
      userId: $userId
    ) {
      id
      conversationId
      userId
      isBot
      content
      supportingContent
      citations
      explanation
      timestamp
      __typename
    }
  }
`;
export const onUpdateConversation = /* GraphQL */ `
  subscription OnUpdateConversation(
    $createdAt: AWSDateTime
    $id: ID
    $summary: String
    $title: String
    $userId: ID
  ) {
    onUpdateConversation(
      createdAt: $createdAt
      id: $id
      summary: $summary
      title: $title
      userId: $userId
    ) {
      id
      userId
      title
      summary
      createdAt
      __typename
    }
  }
`;
export const onUpdateDocument = /* GraphQL */ `
  subscription OnUpdateDocument(
    $content: AWSJSON
    $unique_id: ID
    $s3Uri: String
    $title: String
    $type: String
  ) {
    onUpdateDocument(
      content: $content
      unique_id: $unique_id
      s3Uri: $s3Uri
      title: $title
      type: $type
    ) {
      unique_id
      title
      s3Uri
      type
      content
      uploadedBy
      source
      uploadedAt
      insights
      __typename
    }
  }
`;
export const onUpdateMessage = /* GraphQL */ `
  subscription OnUpdateMessage(
    $content: AWSJSON
    $conversationId: ID
    $id: ID
    $supportingContent: AWSJSON
    $userId: ID
  ) {
    onUpdateMessage(
      content: $content
      conversationId: $conversationId
      id: $id
      supportingContent: $supportingContent
      userId: $userId
    ) {
      id
      conversationId
      userId
      isBot
      content
      supportingContent
      citations
      explanation
      timestamp
      __typename
    }
  }
`;
